// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__2jGHR","col":"styles_col__2J6uO","fulfillmentStatus":"styles_fulfillmentStatus__3OqBj","emailCol":"styles_emailCol__faAzL"};